/* unplugin-vue-components disabled */import { render } from "./ConfigureSpeach.vue?vue&type=template&id=3aee4290&ts=true"
import script from "./ConfigureSpeach.vue?vue&type=script&lang=ts"
export * from "./ConfigureSpeach.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__